// Copyright 2022 - 2023 Fewcha. All rights reserved.

import React, { useEffect, useState } from "react";
import Time from "./Time";

const CountDown: React.FC<{ startTime: string; isStarted: boolean }> = ({ startTime, isStarted }): JSX.Element => {
  const [showTime, setShowTime] = useState<boolean>(false);
  const [date, setDate] = useState<number>(0);
  const [hour, setHour] = useState<number>(0);
  const [minute, setMinute] = useState<number>(0);
  const [second, setSecond] = useState<number>(0);

  useEffect(() => {
    const startTimeEvent = new Date(startTime).getTime();

    if (isStarted || Math.round(startTimeEvent).toString().length > 15) {
      setShowTime(false);
      return;
    }

    const idInterval = setInterval(() => {
      const timeNow = new Date().getTime();
      // const test = 1670172843000;
      const deltaTime = (startTimeEvent - timeNow) / 1000;
      if (deltaTime < 0) {
        setShowTime(false);
        clearInterval(idInterval);
        return;
      }

      setShowTime(true);

      const dateRemain = Math.floor(deltaTime / 86400);
      const timeRemainAfterDate = deltaTime - dateRemain * 86400;

      const hourRemain = Math.floor(timeRemainAfterDate / 3600);
      const timeRemainAfterHasHour = timeRemainAfterDate - hourRemain * 3600;

      const minusRemain = Math.floor(timeRemainAfterHasHour / 60);
      const timeRemainAfterHasMinus = timeRemainAfterHasHour - minusRemain * 60;

      const secondRemain = Math.floor(timeRemainAfterHasMinus);
      setDate(dateRemain);
      setHour(hourRemain);
      setMinute(minusRemain);
      setSecond(secondRemain);
    }, 1000);

    return () => clearInterval(idInterval);
  }, [startTime, isStarted]);

  if (!showTime || isStarted) return <></>;

  return (
    <section className="mt-[56px] flex bg-count-down md:px-[unset] justify-center items-center">
      <div className="max-w-[1024px] text-white">
        {showTime && (
          <div className="md:w-[594.47px] text-center">
            {/* <p className="text-[27px] md:text-[42px] font-second font-light leading-[120%]">It’s coming to town</p> */}
            <p className="text-[27px] md:text-[42px] font-second font-light leading-[120%]">Countdown</p>
            <p className="text-[42px] md:text-[57px] font-second leading-[120%] italic font-extrabold pt-[9px] pb-[65px]">
              Fewcha DAO Rings Collection
            </p>
            {/* <p className=" md:text-[20px] leading-[130%] font-medium py-[34px]">
              Come back to this page on 5th, December 2022
            </p> */}
            <div className="flex gap-x-5 mx-auto items-center justify-center mt-2">
              <Time time={date} type="Date" isDate />
              <Time time={hour} type="Hour" />
              <Time time={minute} type="Minute" />
              <Time time={second} type="Second" isLast />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CountDown;
